import React, { useContext, ReactNode } from "react";
import { classes } from "components/Utility";
import { getTooltipRef, TooltipContext, TooltipProviderValue } from "./TooltipProvider";

export type IconButtonColor = "red" | "green" | "white";

interface Props {
  icon: string, // pick one - all lowercase, words separated by _ ex: AddCard would be add_card https://mui.com/material-ui/material-icons/
  tooltip?: ReactNode,
  className?: string,
  iconColor?: IconButtonColor,
  disabled?: boolean,
  onClick?: React.MouseEventHandler<HTMLElement>, // optional because maybe we just want the icon for its mouseover... but then its not a button!
}

const IconButton = ({ icon, tooltip, className = null, onClick, iconColor = "red", disabled = false }: Props) => {
  const tooltipContext = useContext<TooltipProviderValue>(TooltipContext);

  let style: React.CSSProperties = { cursor: "pointer" };

  if (disabled) {
    style.color = "var(--tertiary-font-color) !important";
  }
  else {
    if (iconColor === "green") style.color = "var(--icon-button-green) !important";
    if (iconColor === "white") style.color = "var(--icon-button-white) !important";
  }
  

  return (
    <i
      ref={tooltip && getTooltipRef(tooltip, tooltipContext)}
      className={classes("md-icon material-icons icon-button mueller-icon-button", className)}
      onClick={disabled ? null : onClick}
      style={style}
    >
      {icon}
    </i>
  );
};

export default IconButton;
